import { Pipe, PipeTransform } from '@angular/core';

import { MissionAcceptanceStatus } from '@enums/mission-acceptance-status.enum';

@Pipe({
  name: 'disabledMissionAcceptanceStatus',
  standalone: true
})
export class DisabledMissionAcceptanceStatusPipe implements PipeTransform {
  transform(currentStatus: MissionAcceptanceStatus, nextStatus: MissionAcceptanceStatus): boolean {
    if ([nextStatus, MissionAcceptanceStatus.validated].includes(currentStatus)) {
      return true;
    }

    return nextStatus === MissionAcceptanceStatus.validated;
  }
}
